"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _NumberUtils = _interopRequireDefault(require("../../utils/NumberUtils"));

var _WithLogic2 = _interopRequireDefault(require("../../utils/WithLogic"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ExpertiseComponent = function ExpertiseComponent(_ExpertiseComponent) {
  return (
    /*#__PURE__*/
    function (_WithLogic) {
      _inherits(_class, _WithLogic);

      function _class(component, options, data) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, component, options, data));
        _this.weightPart = 1;
        _this.totalWeight = 0;

        _this.calculationOption = function () {
          return '';
        };

        return _this;
      }

      _createClass(_class, [{
        key: "setCalculationOption",
        value: function setCalculationOption(option) {
          this.calculationOption = option;
        }
      }, {
        key: "displayScore",
        value: function displayScore() {
          if (this.scoreElem) {
            this.scoreElem.innerText = _NumberUtils.default.formatNumber(this.getCalculatedScore(), this.component.digitsAfterComma);
          }
        }
      }, {
        key: "getCalculationOption",
        value: function getCalculationOption() {
          return this.calculationOption;
        }
      }, {
        key: "getWeight",
        value: function getWeight() {
          return this.component.weight || 1;
        }
      }, {
        key: "getWeightPart",
        value: function getWeightPart() {
          return this.weightPart;
        }
      }, {
        key: "setTotalWeight",
        value: function setTotalWeight(totalWeight, digitsAfterComma) {
          this.totalWeight = totalWeight;
          this.weightPart = this.totalWeight === 0 ? 1 : _NumberUtils.default.round(this.getWeight() / this.totalWeight, digitsAfterComma);
          this.displayScore();
        }
      }, {
        key: "getScore",
        value: function getScore() {}
      }, {
        key: "getWeightedScore",
        value: function getWeightedScore(digitsAfterComma) {
          return _NumberUtils.default.round(this.getScore() * this.getWeight(), digitsAfterComma);
        }
      }, {
        key: "getWeightedPartScore",
        value: function getWeightedPartScore(digitsAfterComma) {
          return _NumberUtils.default.round(this.getScore() * this.getWeightPart(), digitsAfterComma);
        }
      }, {
        key: "getCalculatedScore",
        value: function getCalculatedScore() {
          var calculationOption = this.getCalculationOption()();

          switch (calculationOption) {
            case 'weightedPart':
              return this.getWeightedPartScore();

            default:
              return this.getWeightedScore();
          }
        }
      }, {
        key: "getMinScore",
        value: function getMinScore() {}
      }, {
        key: "getMaxScore",
        value: function getMaxScore() {}
      }, {
        key: "getTitle",
        value: function getTitle() {
          return this.t(this.component.label);
        }
      }, {
        key: "getExpertiseInfo",
        value: function getExpertiseInfo() {
          var calculationOption = this.getCalculationOption()();
          var calculatedScore = this.getCalculatedScore();
          var viewValue = this.getView(this.getValue());
          return {
            key: this.key,
            title: this.getTitle(),
            value: calculatedScore,
            viewValue: viewValue,
            calculationOption: calculationOption,
            weight: this.getWeight(),
            weightPart: this.getWeightPart(),
            score: this.getScore(),
            weightedScore: this.getWeightedScore(),
            weightedPartScore: this.getWeightedPartScore()
          };
        }
      }]);

      return _class;
    }((0, _WithLogic2.default)(_ExpertiseComponent))
  );
};

var _default = ExpertiseComponent;
exports.default = _default;